import PropTypes from 'prop-types';
import { useState , useEffect } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader } from '@mui/material';
//
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader   disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({ navConfig,IsProfile, isCollapse = false, ...other }) {
  const str1 = localStorage.getItem("userMenu");
  const [str, setStr] = useState(str1);
  useEffect(()=>{
    if(str1 && str1!==''){
      const str2 = localStorage.getItem("userMenu");
      setStr(str2);
    }
  },[]);
  const MenuObj = JSON.parse(str);
  const [ListOfMenus, setListOfMenus] = useState([]);

   useEffect(() => {
    if(navConfig && navConfig.length > 0){
      const items = navConfig[0]?.items || [];
      let parsedMenu = null;
      try {
        parsedMenu = str ? JSON.parse(str) : null;
      } catch (e) {
        parsedMenu = null;
      }

      if (!parsedMenu || !Array.isArray(parsedMenu) || parsedMenu.length === 0) {
        setListOfMenus(items);
        return;
      }

      const matchedList = [];
      items.forEach((item) => {
        const found = parsedMenu.some((key) => {
          if (!key.menu_name) return false;
          const mName = key.menu_name.toLowerCase().replace(/[\s_]+/g, '');
          const iTitle = item.title ? item.title.toLowerCase().replace(/[\s_]+/g, '') : '';
          return mName === iTitle ||
                 (mName === 'inbox' && iTitle === 'inbox') ||
                 (mName === 'connect' && (iTitle === 'network' || iTitle === 'connect')) ||
                 (mName === 'institution' && (iTitle === 'profile' || iTitle === 'institution')) ||
                 (mName === 'placements' && (iTitle === 'jobs' || iTitle === 'placements'));
        });
        if (found || item.title === 'Dashboard' || item.title === 'Profile' || item.title === 'Settings') {
          matchedList.push(item);
        }
      });

      setListOfMenus(matchedList.length > 0 ? matchedList : items);
    }
   }, [navConfig, str]);

 

  return (
    <Box {...other} >
      
       <List  className="mainTitle"  disablePadding sx={{ px: 2,mb:5 }}>
          <ListSubheaderStyle
           
            sx={{
              
              ...(isCollapse && {
                opacity: 0,
                
                
              }),
            }}
          >
            {/* {group.subheader} */}
          </ListSubheaderStyle >
          {ListOfMenus.map((list) => (
            <NavListRoot  className="profileTitle"  key={list.title} list={list} isCollapse={isCollapse} />
          ))}
        </List>
    </Box>
  );
}
